import type { WorkInfoPanelItemBase } from '~/types/work/workInfoPanel';

/**
 * 開始作業情報
 */
export type StartWorkInfo = {
  /** チェック状態 */
  checked: boolean;
  /** 伝票読込時にエラーが発生したかどうか */
  isReadError: boolean;
  /** 単位作業ID */
  workId: string;
  /** 枝番 */
  branchNo: string;
  /** 代行枝番 */
  delegateBranchNo: string;
  /** 伝票番号版数 */
  documentEdition: string;
  /** 伝票番号 */
  documentNo: string;
  /** 指定日時 */
  assignDate: string;
  /** 代行便名 */
  delegateFlightName: string;
  /** コンテナ番号 */
  containerNo: string;
  /** コンテナグループ名 */
  containerGroupName: string;
  /** コンテナサイズ */
  containerSize: string;
  /** 点検 */
  containerStatus: string;
  /** 持出駅 */
  outStationName: string;
  /** 持込駅 */
  inStationName: string;
  /** 代行利用者名（封印環番号） */
  delegateUserName: string;
  /** 代行利用者所属JR駅コード */
  delegateStationCd: string;
  /** 代行利用者所属社線駅サブコード */
  delegateStationSubCd: string;
  /** 代行利用者コード */
  delegateUserCompanyCd: string;
  /** 代行集配人コード */
  delegateDeliveryCompanyCd: string;
  /** 伝票に紐づいているオリジナルの代行利用者 */
  originalDelegateUser: {
  /** 代行利用者名 */
    delegateUserName: string;
    /** 代行利用者所属JR駅コード */
    delegateStationCd: string;
    /** 代行利用者所属社線駅サブコード */
    delegateStationSubCd: string;
    /** 代行利用者コード */
    delegateUserCompanyCd: string;
    /** 代行集配人コード */
    delegateDeliveryCompanyCd: string;
  };
  /** お客様名 */
  customerName: string;
  /** 品名 */
  itemName: string;
  /** EDI管理番号 */
  ediNo: string;
  /** 警告確認フラグ */
  emergencyFlg: '0' | '1';
  /** トラックコンテナ積載位置 */
  containerPosition?: '1' | '2' | '3' | '4';
  /** トラックコンテナ扉方向 */
  containerDirection?: '1' | '2' | '3';
  /** トラック積載可能コンテナ数 */
  containerCnt?: '1' | '2' | '3' | '4';
  /** トラックドライバーメッセージID */
  driverMessageId?: string;
  /** トラックドライバーメッセージ */
  driverMessage?: string;
} & WorkInfoPanelItemBase;

type State = {
  /** 読み込んだ開始作業情報 */
  startWorkInfoList: StartWorkInfo[];
};

/**
 * コンテナ持出画面の情報を管理するストア
 */
export const useContainerOutStore = defineStore('container-out', {
  state: (): State => ({
    startWorkInfoList: [],
  }),
});
